<template>
  <div id="login">
    <section class="bannerprincipal pb-5">
      <SiteNav v-if="showNav"></SiteNav>
      <div
        v-if="!showNav"
        class="col-12 text-center"
        data-aos="fade-down"
        data-aos-delay="100"
      ></div>

      <img
        class="w-100 d-block d-lg-none"
        src="../assets/imgs/foroprosa2024/foro2024_header_mobile.jpg"
        alt="Foro Prosa"
      />
      <img
        class="w-100 d-none d-lg-block"
        src="../assets/imgs/foroprosa2024/foro2024_header_desk.jpg"
        alt="Foro Prosa"
      />

      <div class="container">
        <div class="row">
          <div
            class="col-12 col-lg-12 pt-5"
            data-aos="fade-up"
            data-aos-delay="500"
          >
            <div class="row r15">
              <div class="col-12 pt-md-5">
                <div
                  class="row d-flex justify-content-center align-items-center"
                >
                  <div class="col-9">
                    <div class="fG2 pb-2 bold">
                      20 &bull; SEP &bull; 2024 &bull; 08:30 hrs
                    </div>
                    <div class="separador mb-2"></div>
                    <div class="fG bold">
                      Hotel Camino Real Polanco, Terraza Virreyes
                    </div>
                    <div>
                      <a
                        href="https://goo.gl/maps/MWsqZWbZLib6C9op9"
                        target="_blank"
                        >Ver mapa &raquo;</a
                      >
                    </div>
                  </div>
                  <div class="col-3">
                    <img
                      src="../assets/imgs/foroprosa2024/fecha-22-sep-2024.png"
                      alt="Foro Prosa"
                      class="img-fluid"
                    />
                  </div>
                </div>
              </div>

              <div class="col-12 text-left pt-1 pt-md-0 pb-3 mt-n4">
                <p class="fXG2 pb-2 morado bold">Preguntas</p>
                <!-- <p class="negro fG2">
                  Aquí puedes ver y gestionar tu agenda durante el evento:
                </p> -->
              </div>

              <div class="col-12">
                <div class="accordion" role="tablist">
                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1 negro bold" role="tab">
                      <b-button block v-b-toggle.accordion-1 variant="info"
                        >¿Cómo puedo registrarme en las conferencias?</b-button
                      >
                    </b-card-header>
                    <b-collapse
                      id="accordion-1"
                      visible
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text
                          >
                          
                          No es necesario registrarse a las conferencias, tu acceso te permite disfrutar de todas actividades. 
                          </b-card-text
                        >
                        <b-card-text>{{ text }}</b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1 negro bold" role="tab">
                      <b-button block v-b-toggle.accordion-2 variant="info"
                        >¿Cómo encuentro a los ponentes?</b-button
                      >
                    </b-card-header>
                    <b-collapse
                      id="accordion-2"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text>

                          Los nombres de los participantes están disponibles en la sección <router-link to="/ponentes">ponentes</router-link>.

                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <!-- <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1 negro bold" role="tab">
                      <b-button block v-b-toggle.accordion-3 variant="info"
                        >¿Qué hago si no me registro a tiempo?</b-button
                      >
                    </b-card-header>
                    <b-collapse
                      id="accordion-3"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text>

                          El ingreso al evento es solo con un registro previo y validado por Prosa. La fecha límite para recibir tu registro es el 15 de septiembre de 2023.

                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card> -->

                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1 negro bold" role="tab">
                      <b-button block v-b-toggle.accordion-4 variant="info"
                        >
                        ¿Qué hago si no llego a tiempo a una sala?
                        </b-button
                      >
                    </b-card-header>
                    <b-collapse
                      id="accordion-4"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text>

                          Al momento de completarse el aforo no se permitirá el acceso, te recomendamos aprovechar ese espacio para recorrer la zona de stands.

                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>


                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1 negro bold" role="tab">
                      <b-button block v-b-toggle.accordion-5 variant="info"
                        >
                        ¿Cuánto tiempo de tolerancia tengo?
                        </b-button
                      >
                    </b-card-header>
                    <b-collapse
                      id="accordion-5"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text>

                          No existe tolerancia para cada conferencia, por lo que te sugerimos ingresar a la sala 2 minutos antes del inicio. 

                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <!-- <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1 negro bold" role="tab">
                      <b-button block v-b-toggle.accordion-6 variant="info"
                        >
                        ¿Puedo entrar a una sala sin agenda previa?
                        </b-button
                      >
                    </b-card-header>
                    <b-collapse
                      id="accordion-6"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text>

                          Solo es necesario completar tu registro para acceder a todas las actividades.

                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card> -->

                  <!-- <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1 negro bold" role="tab">
                      <b-button block v-b-toggle.accordion-7 variant="info"
                        >
                        ¿Con cuánto tiempo de anticipación puedo y debo registrarme en una conferencia?
                        </b-button
                      >
                    </b-card-header>
                    <b-collapse
                      id="accordion-7"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text>

                          Es recomendable reservar previamente para asegurar tu lugar en alguno de los paneles. Consulta la sección *CONFERENCIAS*

                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card> -->

                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1 negro bold" role="tab">
                      <b-button block v-b-toggle.accordion-8 variant="info"
                        >
                        ¿Existe un límite de registro de conferencias?
                        </b-button
                      >
                    </b-card-header>
                    <b-collapse
                      id="accordion-8"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text>
                          El acceso a las conferencias es limitado, por lo que te sugerimos ingresar con anticipación.

                          

                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1 negro bold" role="tab">
                      <b-button block v-b-toggle.accordion-9 variant="info"
                        >
                        ¿Cuánto tiempo dura cada conferencia?
                        </b-button
                      >
                    </b-card-header>
                    <b-collapse
                      id="accordion-9"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text>

                          El programa de actividades cuenta con presentaciones de 20, 30 y 50 minutos. Consulta la sección  <router-link to="/agenda">agenda</router-link>.

                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <!-- <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1 negro bold" role="tab">
                      <b-button block v-b-toggle.accordion-10 variant="info"
                        >
                        ¿Cuántos invitados o asistentes tiene el evento?
                        </b-button
                      >
                    </b-card-header>
                    <b-collapse
                      id="accordion-10"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text>

                          Tendremos la participación de 20 expertos en diversas áreas y 500 asistentes de México y del resto del mundo.

                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card> -->

                  <!-- <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1 negro bold" role="tab">
                      <b-button block v-b-toggle.accordion-11 variant="info"
                        >
                        ¿Cómo puedo generar una reunión?
                        </b-button
                      >
                    </b-card-header>
                    <b-collapse
                      id="accordion-11"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text>
                          Al hacer login, entra a la sección *Networking* donde podrás ver los perfiles disponibles, selecciona el horario, la sala y presiona agendar cita.

                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1 negro bold" role="tab">
                      <b-button block v-b-toggle.accordion-12 variant="info"
                        >
                        ¿Cómo puedo cancelar una reunión en el módulo “Networking”?
                        </b-button
                      >
                    </b-card-header>
                    <b-collapse
                      id="accordion-12"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text>

                          Pulsa rechazar para cancelar o si lo prefieres puedes elegir otro horario dando clic en el botón proponer nuevo horario.

                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>


                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1 negro bold" role="tab">
                      <b-button block v-b-toggle.accordion-13 variant="info"
                        >
                        ¿Cómo funcionará el Networking?
                        </b-button
                      >
                    </b-card-header>
                    <b-collapse
                      id="accordion-13"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text>

                          Después de agendar una cita tendrás la oportunidad de conectar con otros miembros de la industria en sesiones de 30 minutos, por lo que te pedimos llegar puntual a las salas destinadas para estas actividades.

                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card> -->


                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1 negro bold" role="tab">
                      <b-button block v-b-toggle.accordion-14 variant="info"
                        >
                        ¿Dónde será el evento?
                        </b-button
                      >
                    </b-card-header>
                    <b-collapse
                      id="accordion-14"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text>

                          El evento será en la Terraza Virreyes del Hotel Camino Real Polanco, Piso 7, en la Ciudad de México. La dirección es: Calz. Gral. Mariano Escobedo 700, Anzures, Miguel Hidalgo, 11590 Ciudad de México, CDMX.

                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>


                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1 negro bold" role="tab">
                      <b-button block v-b-toggle.accordion-15 variant="info"
                        >
                        ¿El lugar cuenta con estacionamiento?
                        </b-button
                      >
                    </b-card-header>
                    <b-collapse
                      id="accordion-15"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-card-text>

                          El Hotel Camino Real Polanco, cuenta con estacionamiento privado donde puedes dejar tu auto durante el evento. El costo y condiciones de uso son gestionadas por el Hotel Camino Real Polanco. Cada asistente debe cubrir la tarifa por tiempo de estacionamiento.
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
import SiteNav from "@/components/SiteNav";
import PasswordReset from "@/components/PasswordReset";

import router from "../router/index";

import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";

import { mapState } from "vuex";

export default {
  components: {
    Footer,
    SiteNav,
  },
  data() {
    return {
      mensaje_reenvio: "",
      torneo_db: false,
      clinica_db: false,
      comida_db: false,
      reenvioForm: {
        codigo: "",
      },
      loginForm: {
        no_cliente: "",
        password: "",
      },
      preForm: {
        codigo: "",
        apellido_paterno: "",
        email: "",
      },
      signupForm: {
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
        empresa: "",
        puesto: "",
        email_user: "",
        telefono: "",
        movil: "",
        ext: "",
        terminos: false,
      },
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
      explotar: true,
      id: null,
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
    this.id = this.$route.params.id;
    console.log({ id: this.id });

    if (this.id != undefined) {
      this.traeDatos();
    }
  },
  computed: {
    ...mapState(["userProfile"]),
    showNav() {
      //return Object.keys(this.userProfile).length > 1;
      return true;
    },
  },
  methods: {
    traeDatos() {
      console.log("datos iniciales");
      const https = require("https");
      var qData = {
        codigo: this.id,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "datos-iniciales.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.preForm.codigo = res.datos[0].codigo;
              this.preForm.apellido_paterno = res.datos[0].apellido_paterno;
              this.preForm.email = res.datos[0].email;
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    nuevocodigo() {
      this.reenvioForm.codigo = "";
    },
    cambiaFechaType() {
      this.dateType = "date";
      if (this.signupForm.fecha_nacimiento == "")
        this.signupForm.fecha_nacimiento = "1900-01-01";
    },
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    login(e) {
      this.$store.dispatch("showLoader", true);

      e.preventDefault();

      const https = require("https");
      var qData = {
        no_cliente: this.loginForm.no_cliente,
        email: this.loginForm.email,
        password: this.loginForm.password,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "login2.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              localStorage.setItem(
                "user_foroprosa_2023",
                JSON.stringify(res.usuario)
              );

              router.push("/");
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    presignup(e) {
      e.preventDefault();

      console.log({ presignup: this.preForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.preForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "presignup.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio presingup");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              //swal.fire("Bien", res.msg, "success");

              console.log(res.datos);
              console.log(res.datos[0].codigo);
              console.log(res.datos[0].email);

              this.signupForm.codigo = res.datos[0].codigo;
              this.signupForm.email_user = res.datos[0].email;
              this.signupForm.nombre_1 = res.datos[0].nombre_1.toUpperCase();
              this.signupForm.nombre_2 = res.datos[0].nombre_2.toUpperCase();
              this.signupForm.apellido_paterno =
                res.datos[0].apellido_paterno.toUpperCase();
              this.signupForm.apellido_materno =
                res.datos[0].apellido_materno.toUpperCase();
              this.signupForm.empresa = res.datos[0].empresa.toUpperCase();
              this.signupForm.puesto = res.datos[0].puesto.toUpperCase();
              this.signupForm.telefono = res.datos[0].telefono;
              this.signupForm.movil = res.datos[0].movil;

              if (res.datos[0].tipo == "PATROCINADOR") {
                //
                this.signupForm.clinica = res.datos[0].clinica;
                this.signupForm.torneo = res.datos[0].torneo;
                this.signupForm.comida = res.datos[0].comida;
                this.signupForm.tipo = res.datos[0].tipo;

                this.torneo_db = res.datos[0].torneo;
                this.clinica_db = res.datos[0].clinica;
                this.comida_db = res.datos[0].comida;

                if (this.signupForm.torneo == "SI") {
                  this.signupForm.evento = "Torneo";
                }
                if (this.signupForm.clinica == "SI") {
                  this.signupForm.evento = "Clínica";
                }
              }

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else if (res.status === "reenvio") {
              this.reenvioForm.codigo = res.codigo_reenvio;
              this.mensaje_reenvio = res.msg;

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    reenvio() {
      console.log({ reenvio: this.reenvioForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.reenvioForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "reenvio.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio reenvio");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    signup(e) {
      e.preventDefault();

      console.log({ registro: this.signupForm });
      this.enviaRegistro();
    },
    async enviaRegistro() {
      this.$store.dispatch("showLoader", true);

      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = this.signupForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio registro");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
              this.resetForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    resetForm() {
      this.signupForm = {
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
        empresa: "",
        puesto: "",
        email_user: "",
        telefono: "",
        movil: "",
        ext: "",
        terminos: false,
      };
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    validPhone(celular) {
      if (celular.length < 10) {
        return false;
      }
      if (isNaN(celular)) {
        return false;
      }

      return true;
    },
    changeEvento(e) {
      if (this.signupForm.evento == "Clínica") {
        this.signupForm.clinica = "SI";
        this.signupForm.torneo = "NO";
      } else if (this.signupForm.evento == "Torneo") {
        this.signupForm.clinica = "NO";
        this.signupForm.torneo = "SI";
      } else if (this.signupForm.evento == "Ninguno") {
        this.signupForm.clinica = "NO";
        this.signupForm.torneo = "NO";
      }
      this.signupForm.talla_guantes = "";
      this.signupForm.handicap = "";
      this.signupForm.talla_tops = "";
    },
    changeComida(e) {
      if (this.signupForm.comida == "NO") {
        this.signupForm.torneo = "NO";
        this.signupForm.clinica = "NO";
      }
      this.signupForm.talla_guantes = "";
      this.signupForm.handicap = "";
      this.signupForm.talla_tops = "";
    },
    changeTorneo(e) {
      if (this.signupForm.torneo === "SI") {
        this.signupForm.clinica = "NO";
        this.signupForm.talla_guantes = "";
      } else {
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
      }
    },
    changeClinica(e) {
      if (this.signupForm.clinica === "SI") {
        this.signupForm.torneo = "NO";
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
      } else {
        this.signupForm.talla_guantes = "";
      }
    },
    quitarAcentos(elemento) {
      //console.log('quitando acentos')
      elemento = elemento.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      //console.log({elemento})
      return elemento;
    },
  },
};
</script>
